<template>
    <div class="w-100 vh-100 d-flex align-items-center justify-content-center flex-column bg-body-page">
        <form class="p-3 p-lg-5 col-11 col-md-6 col-lg-4 col-xxl-3 bg-form radio border" @submit.prevent="login">
            <div class="h1-wrapper d-flex justify-content-center">
                <h1><span class="for-sreader"></span></h1>
            </div>
            <div class="mb-3"> 
                <input type="email" v-model="form.email" name="email" class="form-control radio p-3" placeholder="E-mail" aria-describedby="E-mail" required>
            </div>
            <div class="mb-3">
                <input type="password" v-model="form.password" name="password" class="form-control radio p-3" placeholder="Senha" aria-describedby="Senha" required>
            </div>
            <div class="d-flex justify-content-center mb-3">
                <input type="submit" class="radio p-3 text-white form-control" value="Login" style="background:#b98f47; border:none">
            </div>
            <small class="text-warning mb-3" v-if="auth === false">Login incorreto</small>
        </form>
    </div>
</template>
<script>
import Cookies from "js-cookie";

export default {
    name: 'Login',
    data() {
        return {
            form:{
                email: '',
                password: ''
            },
            auth: ''
        }
    },
    mounted() {
        
    },
    methods: {
        login(){
            
            const payload = this.form;
            fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_LOGIN}`, {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(response => response.json())
            .then(res => {
                
                if(res.access_token){
                    this.$store.dispatch('setUser', res.user);
                    Cookies.set('_mysapp_token', res.access_token);
                    this.$router.push('/');
                }else{
                    this.auth = false;
                }
                
            })

        },
    },
}
</script>
<style scoped>
    .bg-form{
        background-color: #754e0a;
    }
    .radio{
        border-radius: 30px;
    }
    .h1-wrapper {
        height: 100px;
        display: block;
        margin-bottom: 20px;
    }
    .h1-wrapper h1 {
        display: block;
        width: 250px;
        height: 100%;
        background: url('https://blendpituba.com.br/static/img/blend-pituba.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: left center;
    }
    .bg-body-page{ 
        background-color: #ffffff;
    }

</style>